import { __assign, __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { httpPut } from '@office-start/xhr-service';
import { MyDrivePath } from '../models/Constants';
import { getFileLocation, } from '../utilities/getFileLocation';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
import { logUploadFeature } from '../utilities/logUploadFeature';
export function uploadSmallFile(_a) {
    var cancellationToken = _a.cancellationToken, _b = _a.conflictBehavior, conflictBehavior = _b === void 0 ? 'rename' : _b, driveId = _a.driveId, file = _a.file, graphXhrOptions = _a.graphXhrOptions, itemId = _a.itemId, onUploadProgress = _a.onUploadProgress, parent = _a.parent, path = _a.path, sessionId = _a.sessionId, setAutoTranscribePreferHeader = _a.setAutoTranscribePreferHeader;
    return __awaiter(this, void 0, void 0, function () {
        var baseFileLocationProps, fileLocationProps, uploadPath, url, requestConfig;
        return __generator(this, function (_c) {
            conflictBehavior = !!itemId ? 'replace' : conflictBehavior;
            baseFileLocationProps = {
                drivePath: driveId ? 'drives/' + driveId + '/' : MyDrivePath,
            };
            fileLocationProps = itemId
                ? __assign(__assign({}, baseFileLocationProps), { itemId: itemId }) : __assign(__assign({}, baseFileLocationProps), { file: file, parent: parent, path: path });
            uploadPath = "".concat(getFileLocation(fileLocationProps), "content?@microsoft.graph.conflictBehavior=").concat(conflictBehavior, "&select=webDavUrl,*");
            url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, uploadPath);
            requestConfig = {
                method: "PUT" /* HttpRequestMethod.Put */,
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            if (setAutoTranscribePreferHeader) {
                requestConfig.headers['Prefer'] = 'autoTranscribe';
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    httpPut(KnownInstrumentationEvents.OneDriveGraphUploadFileRequest, "OneDrive_Graph_Upload_File" /* KnownRequestInstrumentationEvents.OneDriveGraphUploadFileRequest */, url, file, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
                        onUploadProgress: onUploadProgress,
                        populateRequestEvent: function (response, params) {
                            var otelParams = __assign({}, params);
                            otelParams["TotalSize" /* InstrumentationParam.TotalSize */] =
                                file.size.toString();
                            logUploadFeature("OneDrive_Graph_Upload_File" /* KnownRequestInstrumentationEvents.OneDriveGraphUploadFileRequest */, sessionId, response, otelParams);
                        },
                        cancellationToken: cancellationToken,
                    })
                        .then(function (driveItem) {
                        var _a, _b, _c;
                        if (driveItem.data &&
                            driveItem.data.webUrl &&
                            driveItem.data.id) {
                            var fileUrlModel = {
                                canonicalUrl: driveItem.data.webDavUrl,
                                createdByUserGivenName: (_c = (_b = (_a = driveItem.data.createdBy) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.displayName) !== null && _c !== void 0 ? _c : '',
                                docId: driveItem.data.id,
                                downloadUrl: driveItem.data['@microsoft.graph.downloadUrl'],
                                name: driveItem.data.name,
                                webUrl: driveItem.data.webUrl,
                            };
                            // TODO: DO WE NEED TO MODIFY WEBURL?
                            resolve(fileUrlModel);
                        }
                        else {
                            reject({
                                clientError: 'Could not parse drive item from Graph response',
                            });
                        }
                    })
                        .catch(function (error) {
                        var _a, _b;
                        getErrorHandler().handleError(error, "NWgrO" /* ErrorId.NWgrO */);
                        reject(__assign(__assign({}, error), { clientError: (_b = (_a = error.httpResponse.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code }));
                    });
                })];
        });
    });
}
//# sourceMappingURL=uploadSmallFile.js.map